// slices/messageSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  message: null,
  severity: "error",
};

const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setErrorMessage: (state, action) => {
      state.isOpen = true;
      state.message = action.payload;
      state.severity = "error";
    },
    setSuccessMessage: (state, action) => {
      state.isOpen = true;
      state.message = action.payload;
      state.severity = "success";
    },
    closeMessage: (state) => {
      state.isOpen = false;
      state.message = null;
      state.severity = "error";
    },
  },
});

export const { setErrorMessage, setSuccessMessage, closeMessage } =
  messageSlice.actions;

export default messageSlice.reducer;
